var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-mb-1"},[_c('p',{staticClass:"tw-text-gray-400 tw-font-semibold tw-mr-1"},[_vm._v(" "+_vm._s(_vm.label)+": ")]),_c('p',{staticClass:"normal-text secondary-c"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }